/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
var maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
  var duration = 0;
  var timeStep = 50;
  var state = generator.next(duration);
  while (!state.done && duration < maxGeneratorDuration) {
    duration += timeStep;
    state = generator.next(duration);
  }
  return duration >= maxGeneratorDuration ? Infinity : duration;
}
export { calcGeneratorDuration, maxGeneratorDuration };